import NavigationListener from '@apigrowfinance/pbolt-navigation-listener';
import { BrowserRouter } from 'react-router-dom';

import routing from '@components/routing/Routes';
import Routing from '@components/routing/Routing';

const Router = ({ basename }: { basename: string }) => {
    return (
        <BrowserRouter basename={basename}>
            <NavigationListener basename={basename} routes={routing}>
                <Routing />
            </NavigationListener>
        </BrowserRouter>
    );
};

export default Router;
